module.exports = __webpack_public_path__ + "img/1F640.a248e621.svg";